import Request from "../helpers/request-v2"
import Endpoints from "../config/endpoints"
import _ from 'lodash'

export default class MCRequests {


    static getSystemParams() {
        return Request
            .getInstance()
            .createGetRequest(Endpoints.admin.getSystemParameters, {}, {}, true)
            .then(result => !!result ? result.data : null)
    }


    static saveSystemConfig(systemConfig) {
        return Request
            .getInstance()
            .createPostRequest(Endpoints.systemConfig.save, JSON.stringify(systemConfig) , null , true  )
            .then(res=>!!res ? res.data : null )
    }

    static getSystemConfig(code) {
        return Request
            .getInstance()
            .createGetRequest(`${Endpoints.systemConfig.getSystemConfig}/${code}`, {}, {}, true)
            .then(result => {
                return  _.get(result, 'data',  { parameterValue: JSON.stringify({publicArea: true}) })
            })
    }
}


// WEBPACK FOOTER //
// ./src/requests/mc-requests.js